// showToast(msg, lcColor) — Figma-aligned toast for confirmations.
// Pass a CSS color literal or `var(--line-z649)`-style string to tint the border.
let toastTimer = null;

export function showToast(msg, lcColor) {
  const t = document.getElementById("toast");
  if (!t) return;
  const m = document.getElementById("toast-msg");
  if (m) m.textContent = msg;
  t.style.setProperty("--lc", lcColor || "var(--line-z649)");
  t.classList.add("show");
  if (toastTimer) clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    t.classList.remove("show");
    toastTimer = null;
  }, 2200);
}

window.showToast = showToast;
